import { useEffect } from 'react';
import { auth } from '../firebaseConfig';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { paths } from '../config/paths';
import '../styles/Layout.css';
import PropTypes from 'prop-types';
import Header from './Header';
import ApiStatus from './ApiStatus';
import RoleDebugger from './RoleDebugger';


const Layout = ({ children, isPublic = false }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { currentUser, logout } = useAuth();

  const handleSignOut = async () => {
    try {
      await logout();
      // Redirect to Shopify home after logout
      window.location.href = paths.home;
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  useEffect(() => {
    const id = decodeURIComponent(location.hash.replace('#', ''));
    if (!id) return undefined;
    let attempts = 0;
    const timer = window.setInterval(() => {
      const target = document.getElementById(id);
      attempts += 1;
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.clearInterval(timer);
      } else if (attempts > 20) {
        window.clearInterval(timer);
      }
    }, 150);
    return () => window.clearInterval(timer);
  }, [location.pathname, location.hash]);

  const isActive = (path) => {
    return location.pathname === path;
  };

  const handleExternalLink = (e, path) => {
    e.preventDefault();
    window.location.href = path;
  };

  return (
    <div className="layout">
      <Header />
      <main className="main-content">
        {children}
      </main>
      {import.meta.env.DEV && <ApiStatus />}
      {import.meta.env.DEV && <RoleDebugger />}
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  isPublic: PropTypes.bool
};

export default Layout; 